import type {
  CourseThemeMenuResponse,
  UpdateCourseThemesBody
} from '@/models/interface//courseTheme';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

/**
 * 課程主題 API 服務 (學習目標)
 */
export class CourseThemeService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 取得 課程主題清單
   */
  getThemesMenu(): Promise<ApiDataResponse<CourseThemeMenuResponse[]>> {
    return super.get(
      `v1/Theme/GetThemesMenu`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          disableGlobalLoading: true
        }
      }
    );
  }
  /**
   * 更新 課程主題清單
   * @param themes - 課程主題清單酬載
   */
  UpdateThemes(themes: UpdateCourseThemesBody): Promise<ApiDataResponse<undefined>> {
    return super.put(`v1/Theme/UpdateThemes`, themes, {
      headers: {
        'Content-Type': 'application/json',
        disableGlobalLoading: true
      }
    });
  }
}
